// import React, { useState, useEffect } from "react";
// import {
//   BrowserRouter as Router,
//   Routes,
//   Route,
//   useLocation,
// } from "react-router-dom";
// import { Layout } from "antd";
// import Navbar from "./pages/Navbar";
// import Home from "./pages/Home";
// import Dashboard from "./pages/Dashboard";
// import UserPage from "./pages/UserPage";
// import Contact from "./pages/Contact";
// import Register from "./pages/Register";
// import Login from "./pages/Login";
// import AsanaUpload from "./pages/AsanaUpload";
// import AllAsana from "./pages/AllAsana";
// import ViewAsana from "./pages/ViewAsana";
// import EditAsana from "./pages/EditAsana";
// import MyVariations from "./pages/MyVariations";
// import EditVariation from "./pages/EditVariation";
// import ViewVariation from "./pages/ViewVariation";
// import UserRoute from "./Components/UserRoute";
// import AdminRoute from "./Components/AdminRoute";
// import AdminVariationApproval from "./pages/AdminVariationApproval";
// import MakeVariations from "./pages/Admin/MakeVariations";
// import AllMakeVariation from "./pages/Admin/AllMakeVariation";
// import EditMakeVariation from "./pages/Admin/EditMakeVariation";
// import AllPages from "./pages/Admin/AllPages/AllPages";
// import ViewAllPages from "./pages/Admin/AllPages/ViewAllPages";
// import ViewSinglePage from "./pages/Admin/AllPages/ViewSinglePage";
// import EditAllPages from "./pages/Admin/AllPages/EditAllPages";
// import UserAsanaApproval from "./pages/Admin/UserAsanaApproval";
// import AllUserPage from "./pages/Admin/AllUsersPage/AllUserPage";
// import AddUserPage from "./pages/Admin/AllUsersPage/AddUserpage";
// import EditUserPage from "./pages/Admin/AllUsersPage/EditUserPage";
// import AdminMediaLink from "./pages/AdminMediaLink";
// import OverallImages from "./pages/Overallimages";
// import UserRules from "./pages/UserRules";
// import ForgotPassword from "./pages/Auth/ForgotPassword";
// import ResetPassword from "./pages/Auth/ResetPassword";
// import Footer from "./Components/Footer";
// const { Content } = Layout;

// function LayoutWrapper({ user, setUser }) {
//   const location = useLocation();
//   const [isMobile, setIsMobile] = useState(false);

//   useEffect(() => {
//     const check = () => setIsMobile(window.innerWidth <= 768);
//     check();
//     window.addEventListener("resize", check);
//     return () => window.removeEventListener("resize", check);
//   }, []);

//   const showSidebarRoutes = [
//     "/dashboard",
//     "/mainDashboard",
//     "/asana-upload",
//     "/userpage",
//   ];

//   const showSidebar = showSidebarRoutes.some((path) =>
//     location.pathname.startsWith(path),
//   );

//   return (
//     <Layout style={{ minHeight: "100vh", background: "#fafafa" }}>
//       <Navbar user={user} setUser={setUser} />

//       <Layout style={{ marginTop: isMobile ? 60 : 70 }}>
//         <Content style={{ padding: isMobile ? "10px 12px" : "20px 40px", width: "100%" }}>
//           <Routes>
//             <Route path="/" element={<Home setUser={setUser} />} />
//             <Route path="/contact" element={<Contact />} />
//             <Route path="/register" element={<Register />} />
//             <Route path="/login" element={<Login setUser={setUser} />} />
//             <Route path="/forgot-password" element={<ForgotPassword />} />
//             <Route path="/reset-password" element={<ResetPassword />} />

//             <Route
//               path="/dashboard"
//               element={
//                 <AdminRoute user={user}>
//                   <Dashboard user={user} />
//                 </AdminRoute>
//               }
//             />

//             <Route
//               path="/asana-upload"
//               element={
//                 <AdminRoute user={user}>
//                   <AsanaUpload user={user} />
//                 </AdminRoute>
//               }
//             />

//             <Route
//               path="/overall-images"
//               element={
//                 <AdminRoute user={user}>
//                   <OverallImages user={user} />
//                 </AdminRoute>
//               }
//             />

//             <Route
//               path="/all-users"
//               element={
//                 <AdminRoute user={user}>
//                   <AllUserPage user={user} />
//                 </AdminRoute>
//               }
//             />

//             <Route
//               path="/all-asana"
//               element={
//                 <AdminRoute user={user}>
//                   <AllAsana />
//                 </AdminRoute>
//               }
//             />

//             <Route
//               path="/var-approval"
//               element={
//                 <AdminRoute user={user}>
//                   <AdminVariationApproval />
//                 </AdminRoute>
//               }
//             />

//             <Route
//               path="/view-asana/:id"
//               element={
//                 <AdminRoute user={user}>
//                   <ViewAsana />
//                 </AdminRoute>
//               }
//             />

//             <Route
//               path="/edit-asana/:id"
//               element={
//                 <AdminRoute user={user}>
//                   <EditAsana />
//                 </AdminRoute>
//               }
//             />

//             <Route
//               path="/make-variations"
//               element={
//                 <AdminRoute user={user}>
//                   <MakeVariations />
//                 </AdminRoute>
//               }
//             />
//             <Route
//               path="/all-make-variations"
//               element={
//                 <AdminRoute user={user}>
//                   <AllMakeVariation />
//                 </AdminRoute>
//               }
//             />
//             <Route
//               path="/edit-variations/:id"
//               element={
//                 <AdminRoute user={user}>
//                   <EditMakeVariation />
//                 </AdminRoute>
//               }
//             />

//             <Route
//               path="/allpages"
//               element={
//                 <AdminRoute user={user}>
//                   <AllPages user={user} />
//                 </AdminRoute>
//               }
//             />
//             <Route
//               path="/view-allpages"
//               element={
//                 <AdminRoute user={user}>
//                   <ViewAllPages user={user} />
//                 </AdminRoute>
//               }
//             />
//             <Route
//               path="/allpages/view/:id"
//               element={
//                 <AdminRoute user={user}>
//                   <ViewSinglePage user={user} />
//                 </AdminRoute>
//               }
//             />
//             <Route
//               path="/allpages/edit/:id"
//               element={
//                 <AdminRoute user={user}>
//                   <EditAllPages user={user} />
//                 </AdminRoute>
//               }
//             />
//             <Route
//               path="/user-asana-approve"
//               element={
//                 <AdminRoute user={user}>
//                   <UserAsanaApproval user={user} />
//                 </AdminRoute>
//               }
//             />

//             <Route
//               path="/add-user"
//               element={
//                 <AdminRoute user={user}>
//                   <AddUserPage user={user} />
//                 </AdminRoute>
//               }
//             />

//             <Route
//               path="/edit-user/:id"
//               element={
//                 <AdminRoute user={user}>
//                   <EditUserPage user={user} />
//                 </AdminRoute>
//               }
//             />

//             <Route
//               path="/media-link"
//               element={
//                 <AdminRoute user={user}>
//                   <AdminMediaLink user={user} />
//                 </AdminRoute>
//               }
//             />

//             {/* User Protected Pages */}
//             <Route
//               path="/user-page"
//               element={
//                 <UserRoute user={user}>
//                   <UserPage user={user} />
//                 </UserRoute>
//               }
//             />
//             <Route
//               path="/user-rules"
//               element={
//                 <UserRoute user={user}>
//                   <UserRules user={user} />
//                 </UserRoute>
//               }
//             />
//             <Route
//               path="/user-asana-upload"
//               element={
//                 <UserRoute user={user}>
//                   <AsanaUpload user={user} />
//                 </UserRoute>
//               }
//             />

//             <Route
//               path="/my-variation"
//               element={
//                 <UserRoute user={user}>
//                   <MyVariations />
//                 </UserRoute>
//               }
//             />

//             <Route
//               path="/user/edit-variation/:id"
//               element={
//                 <UserRoute user={user}>
//                   <EditVariation />
//                 </UserRoute>
//               }
//             />

//             <Route
//               path="/user/view-variation/:id"
//               element={
//                 <UserRoute user={user}>
//                   <ViewVariation />
//                 </UserRoute>
//               }
//             />
//           </Routes>
//           <Footer />
//         </Content>
//       </Layout>
//     </Layout>
//   );
// }

// function App() {
//   const [user, setUser] = useState(null);
//   const [loadingUser, setLoadingUser] = useState(true);

//   useEffect(() => {
//     const storedUser = localStorage.getItem("user");

//     if (storedUser) {
//       setUser(JSON.parse(storedUser));
//     }

//     setLoadingUser(false);
//   }, []);

//   if (loadingUser) {
//     return <div>Loading...</div>;
//   }

//   return (
//     <Router>
//       <LayoutWrapper user={user} setUser={setUser} />
//     </Router>
//   );
// }

// export default App;

// import React, { useState, useEffect } from "react";
// import {
//   BrowserRouter as Router,
//   Routes,
//   Route,
//   useLocation,
// } from "react-router-dom";
// import { Layout } from "antd";
// import Navbar from "./pages/Navbar";
// import Home from "./pages/Home";
// import Dashboard from "./pages/Dashboard";
// import UserPage from "./pages/UserPage";
// import Contact from "./pages/Contact";
// import Register from "./pages/Register";
// import Login from "./pages/Login";
// import AsanaUpload from "./pages/AsanaUpload";
// import AllAsana from "./pages/AllAsana";
// import ViewAsana from "./pages/ViewAsana";
// import EditAsana from "./pages/EditAsana";
// import MyVariations from "./pages/MyVariations";
// import EditVariation from "./pages/EditVariation";
// import ViewVariation from "./pages/ViewVariation";
// import UserRoute from "./Components/UserRoute";
// import AdminRoute from "./Components/AdminRoute";
// import AdminVariationApproval from "./pages/AdminVariationApproval";
// import MakeVariations from "./pages/Admin/MakeVariations";
// import AllMakeVariation from "./pages/Admin/AllMakeVariation";
// import EditMakeVariation from "./pages/Admin/EditMakeVariation";
// import AllPages from "./pages/Admin/AllPages/AllPages";
// import ViewAllPages from "./pages/Admin/AllPages/ViewAllPages";
// import ViewSinglePage from "./pages/Admin/AllPages/ViewSinglePage";
// import EditAllPages from "./pages/Admin/AllPages/EditAllPages";
// import UserAsanaApproval from "./pages/Admin/UserAsanaApproval";
// import AllUserPage from "./pages/Admin/AllUsersPage/AllUserPage";
// import AddUserPage from "./pages/Admin/AllUsersPage/AddUserpage";
// import EditUserPage from "./pages/Admin/AllUsersPage/EditUserPage";
// import AdminMediaLink from "./pages/AdminMediaLink";
// import OverallImages from "./pages/Overallimages";
// import UserRules from "./pages/UserRules";
// import ForgotPassword from "./pages/Auth/ForgotPassword";
// import ResetPassword from "./pages/Auth/ResetPassword";
// import Footer from "./Components/Footer";
// import useInactivityLogout from "./Components/Useinactivitylogout"; 
// const { Content } = Layout;

// function LayoutWrapper({ user, setUser }) {
//   const location = useLocation();
//   const [isMobile, setIsMobile] = useState(false);

//   // ✅ Inactivity logout + tab close logout runs globally here
//   useInactivityLogout(setUser);

//   useEffect(() => {
//     const check = () => setIsMobile(window.innerWidth <= 768);
//     check();
//     window.addEventListener("resize", check);
//     return () => window.removeEventListener("resize", check);
//   }, []);

//   const showSidebarRoutes = [
//     "/dashboard",
//     "/mainDashboard",
//     "/asana-upload",
//     "/userpage",
//   ];

//   const showSidebar = showSidebarRoutes.some((path) =>
//     location.pathname.startsWith(path),
//   );

//   return (
//     <Layout style={{ minHeight: "100vh", background: "#fafafa" }}>
//       <Navbar user={user} setUser={setUser} />

//       <Layout style={{ marginTop: isMobile ? 60 : 70 }}>
//         <Content style={{ padding: isMobile ? "10px 12px" : "20px 40px", width: "100%" }}>
//           <Routes>
//             <Route path="/" element={<Home setUser={setUser} />} />
//             <Route path="/contact" element={<Contact />} />
//             <Route path="/register" element={<Register />} />
//             <Route path="/login" element={<Login setUser={setUser} />} />
//             <Route path="/forgot-password" element={<ForgotPassword />} />
//             <Route path="/reset-password" element={<ResetPassword />} />

//             <Route
//               path="/dashboard"
//               element={
//                 <AdminRoute user={user}>
//                   <Dashboard user={user} />
//                 </AdminRoute>
//               }
//             />
//             <Route
//               path="/asana-upload"
//               element={
//                 <AdminRoute user={user}>
//                   <AsanaUpload user={user} />
//                 </AdminRoute>
//               }
//             />
//             <Route
//               path="/overall-images"
//               element={
//                 <AdminRoute user={user}>
//                   <OverallImages user={user} />
//                 </AdminRoute>
//               }
//             />
//             <Route
//               path="/all-users"
//               element={
//                 <AdminRoute user={user}>
//                   <AllUserPage user={user} />
//                 </AdminRoute>
//               }
//             />
//             <Route
//               path="/all-asana"
//               element={
//                 <AdminRoute user={user}>
//                   <AllAsana />
//                 </AdminRoute>
//               }
//             />
//             <Route
//               path="/var-approval"
//               element={
//                 <AdminRoute user={user}>
//                   <AdminVariationApproval />
//                 </AdminRoute>
//               }
//             />
//             <Route
//               path="/view-asana/:id"
//               element={
//                 <AdminRoute user={user}>
//                   <ViewAsana />
//                 </AdminRoute>
//               }
//             />
//             <Route
//               path="/edit-asana/:id"
//               element={
//                 <AdminRoute user={user}>
//                   <EditAsana />
//                 </AdminRoute>
//               }
//             />
//             <Route
//               path="/make-variations"
//               element={
//                 <AdminRoute user={user}>
//                   <MakeVariations />
//                 </AdminRoute>
//               }
//             />
//             <Route
//               path="/all-make-variations"
//               element={
//                 <AdminRoute user={user}>
//                   <AllMakeVariation />
//                 </AdminRoute>
//               }
//             />
//             <Route
//               path="/edit-variations/:id"
//               element={
//                 <AdminRoute user={user}>
//                   <EditMakeVariation />
//                 </AdminRoute>
//               }
//             />
//             <Route
//               path="/allpages"
//               element={
//                 <AdminRoute user={user}>
//                   <AllPages user={user} />
//                 </AdminRoute>
//               }
//             />
//             <Route
//               path="/view-allpages"
//               element={
//                 <AdminRoute user={user}>
//                   <ViewAllPages user={user} />
//                 </AdminRoute>
//               }
//             />
//             <Route
//               path="/allpages/view/:id"
//               element={
//                 <AdminRoute user={user}>
//                   <ViewSinglePage user={user} />
//                 </AdminRoute>
//               }
//             />
//             <Route
//               path="/allpages/edit/:id"
//               element={
//                 <AdminRoute user={user}>
//                   <EditAllPages user={user} />
//                 </AdminRoute>
//               }
//             />
//             <Route
//               path="/user-asana-approve"
//               element={
//                 <AdminRoute user={user}>
//                   <UserAsanaApproval user={user} />
//                 </AdminRoute>
//               }
//             />
//             <Route
//               path="/add-user"
//               element={
//                 <AdminRoute user={user}>
//                   <AddUserPage user={user} />
//                 </AdminRoute>
//               }
//             />
//             <Route
//               path="/edit-user/:id"
//               element={
//                 <AdminRoute user={user}>
//                   <EditUserPage user={user} />
//                 </AdminRoute>
//               }
//             />
//             <Route
//               path="/media-link"
//               element={
//                 <AdminRoute user={user}>
//                   <AdminMediaLink user={user} />
//                 </AdminRoute>
//               }
//             />

//             {/* User Protected Pages */}
//             <Route
//               path="/user-page"
//               element={
//                 <UserRoute user={user}>
//                   <UserPage user={user} />
//                 </UserRoute>
//               }
//             />
//             <Route
//               path="/user-rules"
//               element={
//                 <UserRoute user={user}>
//                   <UserRules user={user} />
//                 </UserRoute>
//               }
//             />
//             <Route
//               path="/user-asana-upload"
//               element={
//                 <UserRoute user={user}>
//                   <AsanaUpload user={user} />
//                 </UserRoute>
//               }
//             />
//             <Route
//               path="/my-variation"
//               element={
//                 <UserRoute user={user}>
//                   <MyVariations />
//                 </UserRoute>
//               }
//             />
//             <Route
//               path="/user/edit-variation/:id"
//               element={
//                 <UserRoute user={user}>
//                   <EditVariation />
//                 </UserRoute>
//               }
//             />
//             <Route
//               path="/user/view-variation/:id"
//               element={
//                 <UserRoute user={user}>
//                   <ViewVariation />
//                 </UserRoute>
//               }
//             />
//           </Routes>
//           <Footer />
//         </Content>
//       </Layout>
//     </Layout>
//   );
// }

// function App() {
//   const [user, setUser] = useState(null);
//   const [loadingUser, setLoadingUser] = useState(true);

//   useEffect(() => {
//     // ✅ Check sessionStorage first (clears on tab close)
//     // Fall back to localStorage for any existing sessions
//     const storedUser = sessionStorage.getItem("user");
// const storedToken = sessionStorage.getItem("token");
//     if (storedUser && storedToken) {
//       setUser(JSON.parse(storedUser));
//     } else {
//       // ✅ Clear both if either is missing (avoid partial state)
//       sessionStorage.clear();
//       localStorage.removeItem("token");
//       localStorage.removeItem("user");
//     }

//     setLoadingUser(false);
//   }, []);

//   if (loadingUser) {
//     return <div>Loading...</div>;
//   }

//   return (
//     <Router>
//       <LayoutWrapper user={user} setUser={setUser} />
//     </Router>
//   );
// }

// export default App;

import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { Layout } from "antd";
import Navbar from "./pages/Navbar";
import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import UserPage from "./pages/UserPage";
import Contact from "./pages/Contact";
import Register from "./pages/Register";
import Login from "./pages/Login";
import AsanaUpload from "./pages/AsanaUpload";
import AllAsana from "./pages/AllAsana";
import ViewAsana from "./pages/ViewAsana";
import EditAsana from "./pages/EditAsana";
import MyVariations from "./pages/MyVariations";
import EditVariation from "./pages/EditVariation";
import ViewVariation from "./pages/ViewVariation";
import UserRoute from "./Components/UserRoute";
import AdminRoute from "./Components/AdminRoute";
import AdminVariationApproval from "./pages/AdminVariationApproval";
import MakeVariations from "./pages/Admin/MakeVariations";
import AllMakeVariation from "./pages/Admin/AllMakeVariation";
import EditMakeVariation from "./pages/Admin/EditMakeVariation";
import AllPages from "./pages/Admin/AllPages/AllPages";
import ViewAllPages from "./pages/Admin/AllPages/ViewAllPages";
import ViewSinglePage from "./pages/Admin/AllPages/ViewSinglePage";
import EditAllPages from "./pages/Admin/AllPages/EditAllPages";
import UserAsanaApproval from "./pages/Admin/UserAsanaApproval";
import AllUserPage from "./pages/Admin/AllUsersPage/AllUserPage";
import AddUserPage from "./pages/Admin/AllUsersPage/AddUserpage";
import EditUserPage from "./pages/Admin/AllUsersPage/EditUserPage";
import AdminMediaLink from "./pages/AdminMediaLink";
import OverallImages from "./pages/Overallimages";
import UserRules from "./pages/UserRules";
import ForgotPassword from "./pages/Auth/ForgotPassword";
import ResetPassword from "./pages/Auth/ResetPassword";
import Footer from "./Components/Footer";
import useInactivityLogout from "./Components/Useinactivitylogout";

const { Content } = Layout;

function LayoutWrapper({ user, setUser }) {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(false);

  useInactivityLogout(setUser);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  const showSidebarRoutes = [
    "/dashboard",
    "/mainDashboard",
    "/asana-upload",
    "/userpage",
  ];

  const showSidebar = showSidebarRoutes.some((path) =>
    location.pathname.startsWith(path),
  );

  return (
    <Layout style={{ minHeight: "100vh", background: "#fafafa" }}>
      <Navbar user={user} setUser={setUser} />

      <Layout style={{ marginTop: isMobile ? 60 : 70 }}>
        <Content style={{ padding: isMobile ? "10px 12px" : "20px 40px", width: "100%" }}>
          <Routes>
            <Route path="/" element={<Home setUser={setUser} />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Login setUser={setUser} />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route
              path="/dashboard"
              element={
                <AdminRoute user={user}>
                  <Dashboard user={user} />
                </AdminRoute>
              }
            />
            <Route
              path="/asana-upload"
              element={
                <AdminRoute user={user}>
                  <AsanaUpload user={user} />
                </AdminRoute>
              }
            />
            <Route
              path="/overall-images"
              element={
                <AdminRoute user={user}>
                  <OverallImages user={user} />
                </AdminRoute>
              }
            />
            <Route
              path="/all-users"
              element={
                <AdminRoute user={user}>
                  <AllUserPage user={user} />
                </AdminRoute>
              }
            />
            <Route
              path="/all-asana"
              element={
                <AdminRoute user={user}>
                  <AllAsana />
                </AdminRoute>
              }
            />
            <Route
              path="/var-approval"
              element={
                <AdminRoute user={user}>
                  <AdminVariationApproval />
                </AdminRoute>
              }
            />
            <Route
              path="/view-asana/:id"
              element={
                <AdminRoute user={user}>
                  <ViewAsana />
                </AdminRoute>
              }
            />
            <Route
              path="/edit-asana/:id"
              element={
                <AdminRoute user={user}>
                  <EditAsana />
                </AdminRoute>
              }
            />
            <Route
              path="/make-variations"
              element={
                <AdminRoute user={user}>
                  <MakeVariations />
                </AdminRoute>
              }
            />
            <Route
              path="/all-make-variations"
              element={
                <AdminRoute user={user}>
                  <AllMakeVariation />
                </AdminRoute>
              }
            />
            <Route
              path="/edit-variations/:id"
              element={
                <AdminRoute user={user}>
                  <EditMakeVariation />
                </AdminRoute>
              }
            />
            <Route
              path="/allpages"
              element={
                <AdminRoute user={user}>
                  <AllPages user={user} />
                </AdminRoute>
              }
            />
            <Route
              path="/view-allpages"
              element={
                <AdminRoute user={user}>
                  <ViewAllPages user={user} />
                </AdminRoute>
              }
            />
            <Route
              path="/allpages/view/:id"
              element={
                <AdminRoute user={user}>
                  <ViewSinglePage user={user} />
                </AdminRoute>
              }
            />
            <Route
              path="/allpages/edit/:id"
              element={
                <AdminRoute user={user}>
                  <EditAllPages user={user} />
                </AdminRoute>
              }
            />
            <Route
              path="/user-asana-approve"
              element={
                <AdminRoute user={user}>
                  <UserAsanaApproval user={user} />
                </AdminRoute>
              }
            />
            <Route
              path="/add-user"
              element={
                <AdminRoute user={user}>
                  <AddUserPage user={user} />
                </AdminRoute>
              }
            />
            <Route
              path="/edit-user/:id"
              element={
                <AdminRoute user={user}>
                  <EditUserPage user={user} />
                </AdminRoute>
              }
            />
            <Route
              path="/media-link"
              element={
                <AdminRoute user={user}>
                  <AdminMediaLink user={user} />
                </AdminRoute>
              }
            />

            {/* User Protected Pages */}
            <Route
              path="/user-page"
              element={
                <UserRoute user={user}>
                  <UserPage user={user} />
                </UserRoute>
              }
            />
            <Route
              path="/user-rules"
              element={
                <UserRoute user={user}>
                  <UserRules user={user} />
                </UserRoute>
              }
            />
            <Route
              path="/user-asana-upload"
              element={
                <UserRoute user={user}>
                  <AsanaUpload user={user} />
                </UserRoute>
              }
            />
            <Route
              path="/my-variation"
              element={
                <UserRoute user={user}>
                  <MyVariations />
                </UserRoute>
              }
            />
            <Route
              path="/user/edit-variation/:id"
              element={
                <UserRoute user={user}>
                  <EditVariation />
                </UserRoute>
              }
            />
            <Route
              path="/user/view-variation/:id"
              element={
                <UserRoute user={user}>
                  <ViewVariation />
                </UserRoute>
              }
            />
          </Routes>
          <Footer />
        </Content>
      </Layout>
    </Layout>
  );
}

function App() {
  const [user, setUser] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);

  useEffect(() => {
    // ✅ FIXED: Only read from sessionStorage
    // ❌ REMOVED: localStorage fallback — was keeping user logged in after logout + refresh
    const storedUser = sessionStorage.getItem("user");
    const storedToken = sessionStorage.getItem("token");

    if (storedUser && storedToken) {
      setUser(JSON.parse(storedUser));
    } else {
      // Clear sessionStorage if either is missing
      sessionStorage.clear();
    }

    setLoadingUser(false);
  }, []);

  if (loadingUser) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <LayoutWrapper user={user} setUser={setUser} />
    </Router>
  );
}

export default App;